// Core
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';

// Chakra imports
import { Box } from '@chakra-ui/react';

// Components
import MarketPrice from './MarketPrice';
import MarketPriceEdit from './MarketPriceEdit';
import usePermissionStatusByKey from '../../../hooks/usePermissionStatusByKey';

function MarketPrices(props) {
  const { path } = useRouteMatch();

  const isMarketPrices = usePermissionStatusByKey('GET:/admin/market-prices');
  const isCreateMarketPrice = usePermissionStatusByKey(
    'POST:/admin/market-prices',
  );

  return (
    <>
      <Box>
        <Switch>
          <Route
            path={`${path}/:id(new|\\d+)`}
            render={() => <MarketPriceEdit />}
          />
          {(isMarketPrices || isCreateMarketPrice) && (
            <Route path={`${path}`} render={() => <MarketPrice />} />
          )}

          <Redirect from={`${path}*`} to={`${path}`} />
        </Switch>
      </Box>
    </>
  );
}

export default MarketPrices;
